module.exports = __webpack_public_path__ + "img/icon_zhjc.4012a1c6.png";